import { render, staticRenderFns } from "./SettingsCalendarViewPage.vue?vue&type=template&id=734e162c"
import script from "./SettingsCalendarViewPage.vue?vue&type=script&lang=ts"
export * from "./SettingsCalendarViewPage.vue?vue&type=script&lang=ts"
import style0 from "./SettingsCalendarViewPage.vue?vue&type=style&index=0&id=734e162c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports